import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsInputNumber from '../../components/lottus/lts-input-number'
import LtsDropdownUnidade from '../../components/lottus/lts-dropdown-unidade'
import { getMessage } from '../../utils'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function TransferirEstoque(props) {
  const [quantidade, setQuantidade] = useState(0)
  const [unidadeDestino, setUnidadeDestino] = useState()

  useEffect(() => {
    resetValues()
  }, [props.visible])

  const isConfirmarDisabled = () => {
    return !_.isNumber(quantidade) || !unidadeDestino
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    props.onConfirm({ quantidade, unidadeDestino, produtoUnidade: props.data })
    onHide()
  }

  const resetValues = () => {
    setQuantidade(props.data.saldo)
    setUnidadeDestino(null)
  }

  const afterLoadUnidadeDestino = (data) => {
    if (!data) {
      return data
    }
    return data.filter((d) => d.id !== _.get(props, 'data.unidade.id', -1))
  }

  return (
    <Dialog
      header={getMessage(props.messages, 'produto.label.transferirEstoque')}
      visible={props.visible}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid margin-top-dialogs">
        <div className="form-group p-col-12">
          <LtsDropdownUnidade
            name={'unidadeDestino'}
            label={getMessage(props.messages, 'produto.label.unidadeDestino')}
            value={unidadeDestino}
            onChange={(e) => setUnidadeDestino(e)}
            showOptionAll={false}
            afterLoadDataFn={afterLoadUnidadeDestino}
          />
        </div>
        <div className="form-group p-col-6">
          <LtsInputNumber
            min={-9999999}
            max={props.data.saldo}
            value={quantidade}
            onChange={(e) => setQuantidade(e)}
            name={'quantidade'}
            label={getMessage(props.messages, 'produto.label.quantidade')}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={_.defaultTo(props.labelConfirmar, 'Confirmar')}
            onClick={() => {
              onConfirm()
            }}
            disabled={isConfirmarDisabled()}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
